// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stats {
  display: grid;
  grid-gap: 10px;
  grid-template-columns: repeat(auto-fit, minmax(110px, 1fr));
}

.stat-cell .inner {
  text-align: center;
  border-radius: 8px;
  padding: 10px;
  cursor: pointer;
}
.stat-cell .line1 {
  font-size: 2rem;
  line-height: 2.1rem;
  font-weight: 600;
}
.stat-cell .line2 {
  font-size: 1.1rem;
  line-height: 1.1rem;
  font-weight: 500;
  letter-spacing: -0.5px;
}
.stat-cell .line3 {
  font-size: 0.9rem;
  line-height: 0.9rem;
  font-weight: 300;
  letter-spacing: 0px;
}

.chart-title {
  padding: 8px;
  margin-top: 10px;
  font-weight: 500;
}

.pageheader {
  text-align: center;
  font-weight: bold;
  padding-bottom: 10px;
}

canvas {
  width: 100% !important;
  height: 100% !important;
}

.filter-section {
  display: flex;
  grid-gap: 12px;
}

.adminstatus-2 {
  color: var(--warningColour);
}

.adminstatus-3, .adminstatus-4 {
  color: var(--dangerColour);
}

.table-container {
  background: white;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  height: 100%;
}
.table-container .table-title {
  margin-bottom: 15px;
  color: #333;
  font-weight: 600;
}
.table-container .table-responsive {
  max-height: 400px;
  overflow-y: auto;
}
.table-container .table {
  margin-bottom: 0;
}
.table-container .table th {
  background-color: #f8f9fa;
  border-top: none;
  font-weight: 600;
  font-size: 0.9rem;
  padding: 12px 8px;
}
.table-container .table td {
  padding: 10px 8px;
  font-size: 0.9rem;
  vertical-align: middle;
}
.table-container .table td.customer-name {
  font-weight: 500;
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.table-container .table .table-row-limit {
  display: none;
}

.chart-title {
  background: white;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  height: 100%;
  font-weight: 600;
  color: #333;
  margin-bottom: 15px;
}

@media (max-width: 768px) {
  .col-md-8, .col-md-4 {
    margin-bottom: 20px;
  }
  .table-container .table-responsive {
    max-height: 300px;
  }
}
.row .col-md-4 {
  margin-bottom: 20px;
}
.row .col-md-4 .chart-title {
  min-height: 350px;
}

.chart-title {
  display: flex;
  flex-direction: column;
}
.chart-title app-dashboard-trendline-chart {
  flex: 1;
  min-height: 250px;
}`, "",{"version":3,"sources":["webpack://./projects/remarq/src/app/components/admin/dashboard/admin-dashboard.component.scss","webpack://./projects/remarq/src/app/components/admin/dashboard/kpis/admin-kpis.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,cAAA;EACA,2DAAA;ACCF;;ADIE;EACE,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;ACDJ;ADIE;EACE,eAAA;EACA,mBAAA;EACA,gBAAA;ACFJ;ADKE;EACE,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,sBAAA;ACHJ;ADME;EACE,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;ACJJ;;ADUA;EACE,YAAA;EACA,gBAAA;EACA,gBAAA;ACPF;;ADUA;EACE,kBAAA;EACA,iBAAA;EACA,oBAAA;ACPF;;ADUA;EACE,sBAAA;EACA,uBAAA;ACPF;;ADUA;EACE,aAAA;EACA,cAAA;ACPF;;ADUA;EACE,2BAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;AAtDA;EACE,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,wCAAA;EACA,YAAA;AAyDF;AAvDE;EACE,mBAAA;EACA,WAAA;EACA,gBAAA;AAyDJ;AAtDE;EACE,iBAAA;EACA,gBAAA;AAwDJ;AArDE;EACE,gBAAA;AAuDJ;AArDI;EACE,yBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;AAuDN;AApDI;EACE,iBAAA;EACA,iBAAA;EACA,sBAAA;AAsDN;AApDM;EACE,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAsDR;AAlDI;EACE,aAAA;AAoDN;;AA9CA;EACE,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,wCAAA;EACA,YAAA;EAEA,gBAAA;EACA,WAAA;EACA,mBAAA;AAgDF;;AA5CA;EACE;IACE,mBAAA;EA+CF;EA3CE;IACE,iBAAA;EA6CJ;AACF;AAvCE;EACE,mBAAA;AAyCJ;AAvCI;EACE,iBAAA;AAyCN;;AAnCA;EACE,aAAA;EACA,sBAAA;AAsCF;AApCE;EACE,OAAA;EACA,iBAAA;AAsCJ","sourcesContent":[".stats {\n  display: grid;\n  grid-gap: 10px;\n  grid-template-columns: repeat(auto-fit, minmax(110px, 1fr));\n}\n\n.stat-cell {\n\n  .inner {\n    text-align: center;\n    border-radius: 8px;\n    padding: 10px;\n    cursor: pointer;\n  }\n\n  .line1 {\n    font-size: 2rem;\n    line-height: 2.1rem;\n    font-weight: 600;\n  }\n\n  .line2 {\n    font-size: 1.1rem;\n    line-height: 1.1rem;\n    font-weight: 500;\n    letter-spacing: -0.5px;\n  }\n\n  .line3 {\n    font-size: 0.9rem;\n    line-height: 0.9rem;\n    font-weight: 300;\n    letter-spacing: -0px;\n  }\n\n}\n\n\n.chart-title {\n  padding: 8px;\n  margin-top: 10px;\n  font-weight: 500;\n}\n\n.pageheader {\n  text-align: center;\n  font-weight: bold;\n  padding-bottom: 10px;\n}\n\ncanvas {\n  width: 100% !important;\n  height: 100% !important;\n}\n\n.filter-section {\n  display: flex;\n  grid-gap: 12px;\n}\n\n.adminstatus-2 {\n  color: var(--warningColour);\n}\n\n.adminstatus-3, .adminstatus-4 {\n  color: var(--dangerColour);\n}\n","// Import the main dashboard styles\n@import '../admin-dashboard.component.scss';\n\n// Additional styles specific to KPIs component\n.table-container {\n  background: white;\n  border-radius: 8px;\n  padding: 20px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  height: 100%;\n\n  .table-title {\n    margin-bottom: 15px;\n    color: #333;\n    font-weight: 600;\n  }\n\n  .table-responsive {\n    max-height: 400px;\n    overflow-y: auto;\n  }\n\n  .table {\n    margin-bottom: 0;\n\n    th {\n      background-color: #f8f9fa;\n      border-top: none;\n      font-weight: 600;\n      font-size: 0.9rem;\n      padding: 12px 8px;\n    }\n\n    td {\n      padding: 10px 8px;\n      font-size: 0.9rem;\n      vertical-align: middle;\n\n      &.customer-name {\n        font-weight: 500;\n        max-width: 150px;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n      }\n    }\n\n    .table-row-limit {\n      display: none; // Hide rows beyond the 10th\n    }\n  }\n}\n\n// Ensure chart container has proper styling\n.chart-title {\n  background: white;\n  border-radius: 8px;\n  padding: 20px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  height: 100%;\n\n  font-weight: 600;\n  color: #333;\n  margin-bottom: 15px;\n}\n\n// Responsive adjustments\n@media (max-width: 768px) {\n  .col-md-8, .col-md-4 {\n    margin-bottom: 20px;\n  }\n\n  .table-container {\n    .table-responsive {\n      max-height: 300px;\n    }\n  }\n}\n\n// Additional charts styling\n.row {\n  .col-md-4 {\n    margin-bottom: 20px;\n\n    .chart-title {\n      min-height: 350px; // Ensure consistent height for the three charts\n    }\n  }\n}\n\n// Ensure all charts have consistent spacing\n.chart-title {\n  display: flex;\n  flex-direction: column;\n\n  app-dashboard-trendline-chart {\n    flex: 1;\n    min-height: 250px;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
